import { Response } from '@marketplace-web/core-api/api-client-util'
import { ProductItemModel, transformItemBoxDto } from '@marketplace-web/item-box/product-item-data'

import {
  BumpableItemDto,
  BumpableItemModel,
  BumpableItemPhotoDto,
  BumpableItemPreCheckoutModel,
  GetBumpableItemsResp,
} from '../types/bumpable-items'
import { ItemThumbnailSize } from '../constants/close-promotions'
import { transformCurrencyAmountDto } from './currency'

export const getBumpableItemThumbnailFromDto = (
  photos: Array<BumpableItemPhotoDto> | undefined,
  size = ItemThumbnailSize.Large,
) => {
  return (
    photos?.find(photo => photo.is_main)?.thumbnails?.find(thumb => thumb.type === size)?.url ||
    null
  )
}

export const getBumpableItemDataFromModel = (
  item: ProductItemModel | BumpableItemModel,
): BumpableItemPreCheckoutModel => {
  return {
    id: item.id,
    title: item.title,
    thumbnail: item.thumbnailUrl,
  }
}

export const getThumbnailFromBumpableItemDto = (
  photo: BumpableItemPhotoDto,
  size = ItemThumbnailSize.Large,
) => {
  return photo.thumbnails.find(thumb => thumb.type === size)?.url || null
}

export const transformBumpItemDtoToModel = (item: BumpableItemDto): BumpableItemModel => ({
  id: item.id,
  title: item.title,
  thumbnailUrl: item.photo ? getThumbnailFromBumpableItemDto(item.photo) : null,
  price: transformCurrencyAmountDto(item.price),
  dominantColor: item.photo?.dominant_color_opaque || null,
  itemBox: item.item_box && transformItemBoxDto(item.item_box),
})

export const transformBumpItems = (items: Array<BumpableItemDto>): Array<BumpableItemModel> =>
  items.map(transformBumpItemDtoToModel)

export const transformBumpableItemsResponse = (response: Response<GetBumpableItemsResp>) => ({
  items: transformBumpItems(response.items),
  pageInfo: { hasMore: response.page_info.has_more },
})
